import { gql } from "@apollo/client";
import ProbablesFragment from "../fragments/Probables";

export default gql`
  subscription racesUpdate($wagerProfile: String!, $tvgRaceIds: [Long]) {
    raceProbablesUpdate(profile: $wagerProfile, tvgRaceIds: $tvgRaceIds) {
      id
      tvgRaceId
      ...Probables
    }
  }
  ${ProbablesFragment}
`;
